module.exports = __webpack_public_path__ + "static/img/rules-banner.532eb9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rules-banner.jpg
// module id = 853
// module chunks = 0